'use client';
import { isEmpty } from '@/utils/isEmpty';
import { FC, useEffect } from 'react';

import { productDetailPayloadToBaseCarData } from 'src/data/ProductApi/ProductDetailPayloadToBaseCarData';
import { IntersectionObserverHandler } from 'src/general/components/IntersectionObserverHandler/IntersectionObserverHandler';
import { ProductCard } from 'src/general/components/ProductCard/ProductCard';
import { pushCarmaRecommendationEvent } from 'src/general/helpers/pushCarmaRecommendationEvent';
import { ProductListDataPayload } from 'src/types/CataloguePage.types';
import { pushToDataLayerFeatureEngagement } from 'src/utils/pushToDataLayerFeatureEngagement';

import { ProductGrid } from '../ProductGrid/ProductGrid';
import { SuggestionType } from '../Results/ResultsSuggestions';

interface SimilarCarsGridProps {
  results: ProductListDataPayload['results'];
  title?: string;
  suggestionType: SuggestionType;
  recommendationId: string | null;
}

export const SuggestedCarsGridContent: FC<SimilarCarsGridProps> = ({
  results,
  title,
  suggestionType,
  recommendationId,
}) => {
  useEffect(() => {
    pushToDataLayerFeatureEngagement({
      event: 'feature_engagement',
      payload: {
        feature: suggestionType,
        type: 'load',
        component: 'list',
      },
    });
  }, [suggestionType]);

  return (
    <IntersectionObserverHandler
      margins="-50%"
      onIntersecting={() => {
        pushToDataLayerFeatureEngagement({
          event: 'feature_engagement',
          payload: {
            feature: suggestionType,
            type: 'view',
            component: 'list',
          },
        });
      }}
    >
      {!isEmpty(title) && (
        <header className="mb-6">
          <h2 className="c-fs-h4 font-extrabold">{title}</h2>
        </header>
      )}
      <ProductGrid>
        {results.map((product, index) => (
          <ProductCard
            key={product.sku}
            carData={productDetailPayloadToBaseCarData(product)}
            weeklyRepayment={product.weeklyRepayment}
            defaultRate={product.defaultRate}
            variant="plp"
            onCardClick={() => {
              pushToDataLayerFeatureEngagement({
                event: 'feature_engagement_click',
                payload: {
                  feature: suggestionType,
                  type: 'click',
                  component: 'list',
                  sku: product.sku,
                  index,
                },
              });
              pushCarmaRecommendationEvent(
                suggestionType === 'similarCars' ? 'similar' : 'recommended',
                results,
                recommendationId,
              )(product.sku);
            }}
          />
        ))}
      </ProductGrid>
    </IntersectionObserverHandler>
  );
};
